/**
 * `POST /api/cart/sync-login` — merge a logged-out guest cart into the
 * authenticated user's cart on sign-in. The route derives `userId` from the
 * session (Bearer/cookie) and reads `guestId` from the body. Existing
 * callers also pass `userId` in the body for symmetry with sync-logout;
 * the route ignores it but we surface it as optional on the request shape
 * so historical wire shape stays representable.
 *
 * Response: `{ success: true }`.
 *
 * @see app/api/cart/sync-login/route.ts — handler
 * @see lib/cart/sync-login-cart.ts — builder
 */

import { z } from "zod";
import { pinned } from "./pin";

export interface CartSyncLoginRequest {
  guestId: string;
  /** Ignored by the route (session is source of truth) — kept for client-side parity. */
  userId?: string;
}

export interface CartSyncLoginResponse {
  success: true;
}

export const CartSyncLoginRequestSchema = pinned<CartSyncLoginRequest>()(
  z.object({
    guestId: z.string().min(1),
    userId: z.string().min(1).optional(),
  }),
);

export const CartSyncLoginResponseSchema = pinned<CartSyncLoginResponse>()(
  z.object({
    success: z.literal(true),
  }),
);
